export const SENTRY_TAGS = Object.freeze({
  ScreenId: 'screenId',
  OrganizationId: 'organizationId',
});

export const SENTRY_EVENTS = Object.freeze({
  StartSessionReplay: 'StartSessionReplay',
});
